import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-021ec911"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "message-area" }
const _hoisted_3 = {
  key: 0,
  class: "name"
}
const _hoisted_4 = {
  key: 0,
  ref: "dropdownRef",
  class: "dropdown-inner"
}
const _hoisted_5 = {
  key: 0,
  class: "message-reference-area-show"
}
const _hoisted_6 = {
  key: 0,
  class: "face-box"
}
const _hoisted_7 = {
  key: 0,
  class: "text-box"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-voice" }, null, -1))
const _hoisted_12 = {
  key: 4,
  class: "message-video-cover"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "message-reference-area-show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["message-bubble", [_ctx.message.flow === 'in' ? '' : 'reverse']]),
      ref: "htmlRefHook"
    }, [
      _createElementVNode("img", {
        class: "avatar",
        src: _ctx.message?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
        onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
      }, null, 8, _hoisted_1),
      _createElementVNode("main", _hoisted_2, [
        (_ctx.message.flow === 'in' && _ctx.message.conversationType === 'GROUP')
          ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.message.nameCard || _ctx.message.nick || _ctx.message.from), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['content content-' + _ctx.message.flow]),
          onContextmenu: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDialog && _ctx.toggleDialog(...args)), ["prevent","right"]))
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          (_ctx.dropdown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(["dialog", [_ctx.message.flow === 'in' ? '' : 'dialog-right']]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dropdown = false))
                }, [
                  _renderSlot(_ctx.$slots, "dialog", {}, undefined, true)
                ], 2)
              ], 512))
            : _createCommentVNode("", true)
        ], 34)
      ]),
      (_ctx.message.status === 'fail')
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: "message-label fail",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resendMessage(_ctx.message)))
          }, "!"))
        : _createCommentVNode("", true),
      (_ctx.showReadReceiptTag(_ctx.message))
        ? (_openBlock(), _createElementBlock("label", {
            key: 1,
            class: _normalizeClass(["message-label", _ctx.readReceiptStyle(_ctx.message)]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showReadReceiptDialog(_ctx.message)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.readReceiptCont(_ctx.message)), 1)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.message.cloudCustomData && _ctx.referenceMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["message-reference-area", [_ctx.message.flow === 'in' ? '' : 'message-reference-area-reverse']]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.jumpToAim(_ctx.referenceMessage)))
        }, [
          (_ctx.referenceMessage?.messageID && _ctx.allMessageID.indexOf(_ctx.referenceMessage.messageID) !== -1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.referenceForShow.nick || _ctx.referenceForShow.from) + ":", 1),
                (_ctx.referenceMessage.messageType === _ctx.type.typeText)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.face, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (item.name === 'text')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.text), 1))
                            : (item.name === 'img')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  class: "text-img",
                                  src: item.src
                                }, null, 8, _hoisted_8))
                              : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.referenceMessage.messageType === _ctx.type.typeCustom)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.referenceMessage.messageAbstract), 1))
                  : _createCommentVNode("", true),
                (_ctx.referenceMessage.messageType === _ctx.type.typeImage)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      class: "message-img",
                      src: _ctx.referenceForShow.payload.imageInfoArray[1].url
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true),
                (_ctx.referenceMessage.messageType === _ctx.type.typeAudio)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(["message-audio", [_ctx.message.flow === 'out' && 'reserve']])
                    }, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.referenceForShow.payload.second) + "s", 1),
                      _hoisted_11
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.referenceMessage.messageType === _ctx.type.typeVideo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("img", {
                        class: "message-videoimg",
                        src: _ctx.referenceForShow.payload.snapshotUrl
                      }, null, 8, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.referenceMessage.messageType === _ctx.type.typeFace)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 5,
                      class: "message-img",
                      src: _ctx.url
                    }, null, 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(_ctx.referenceMessage?.messageSender), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.referenceMessage?.messageAbstract), 1)
              ]))
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}